import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { ESCAPE, Subscriber, getGlobalBehaviors } from '@cian/global-behaviors';
/**
 * Компонента для добавления подписки на Escape через @cian/global-behaviors
 *
 * Добавление подписчика происходит после монтирования компоненты
 * Удаление подписчика происходит после размонтирования компоненты
 *
 * Рендерить компоненту нужно ТОЛЬКО в случаях если что-то реально отрендерится на экране
 *
 * @export
 * @param {IEscapeProps} props
 * @returns
 */
export class Escape extends React.Component {
  constructor() {
    super(...arguments);
    /**
     * По причине того, чтобы ссылка на эту функцию не менялась
     * Эту компоненту нельзя делать функциональной
     */
    _defineProperty(this, "subscriber", new Subscriber(() => {
      if (this.props.active) {
        this.props.onEscape();
      }
    }));
  }
  componentDidMount() {
    getGlobalBehaviors().subscribe(ESCAPE, this.subscriber);
  }
  componentWillUnmount() {
    getGlobalBehaviors().unsubscribe(ESCAPE, this.subscriber);
  }
  render() {
    var _this$props$children;
    return (_this$props$children = this.props.children) !== null && _this$props$children !== void 0 ? _this$props$children : null;
  }
}
_defineProperty(Escape, "defaultProps", {
  active: true
});